var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'loader-wrapper': true, 'loader-wrapper--active': _vm.isLoading, 'loader-wrapper--full-height': _vm.fullHeight}},[_vm._t("default"),_c('b-loading',{attrs:{"is-full-page":_vm.isFullPage,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}})],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66172f2b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../panel-theme/src/js/widgets/ds-loader.vue
// module id = null
// module chunks = 